<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
      <legend>Users</legend>
      <div class="row">
        <div>
          <b-form inline>
            <label class="sr-only" for="inline-form-input-name">Receivers</label>
            <b-form-textarea id="textarea" v-model="SmsDtoType.receivers" placeholder="Receivers" rows="3"
              max-rows="6"></b-form-textarea>
            <label class="sr-only" for="inline-form-input-name">Message</label>
            <b-form-textarea id="textarea" v-model="SmsDtoType.message" placeholder="message" rows="3"
              max-rows="6"></b-form-textarea>
            <b-button @click="onSendSms()" variant="primary">Send</b-button>
          </b-form>
        </div>
        <br />
        <br />
      </div>
      <b-overlay :show="busy" no-wrap>
        <template #overlay>
          <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
            <b-icon icon="cloud" font-scale="4"></b-icon>
            <div class="mb-3">Processing...</div>
            <div class="text-center">
              <b-spinner type="grow" label="Spinning"></b-spinner>
            </div>
          </div>
        </template>
      </b-overlay>
    </div>
  </main>
  <!--Main layout-->
</div>